module.exports = __webpack_public_path__ + "static/media/physiowerk-logo.167d71dc.svg";